import s from './VowMark.module.css';

/**
 * VowMark — the AVOWAL mark making its vow.
 *
 * Four beats, all pure SVG + CSS (no dependencies, ~1 KB):
 *   1. the A draws itself like a pen stroke (the vow being written),
 *   2. a signature line follows beneath it (the attorney signs),
 *   3. the seal lands at the counter with a single expanding ring (attestation),
 *   4. forever after, a quiet glint travels the stroke (verification, ongoing).
 *
 * Every path carries pathLength=1 so the dash choreography is unit-based and
 * independent of geometry. prefers-reduced-motion renders the final state,
 * static. Decorative only: aria-hidden, pointer-events none.
 */
export default function VowMark() {
  return (
    <div className={s.wrap} aria-hidden="true">
      <svg viewBox="0 0 120 126" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="vowmark-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00d4ff" />
            <stop offset="100%" stopColor="#f0b429" />
          </linearGradient>
        </defs>
        {/* 1 — the vow: the A-mark draws itself */}
        <path
          className={s.stroke}
          d="M60 10 L108 100 L84 100 L60 52 L36 100 L12 100 Z"
          pathLength={1}
        />
        {/* 4 — verification: a glint that travels the stroke, forever */}
        <path
          className={s.glint}
          d="M60 10 L108 100 L84 100 L60 52 L36 100 L12 100 Z"
          pathLength={1}
        />
        {/* 2 — the signature beneath */}
        <path className={s.sig} d="M10 116 C 42 110, 78 122, 110 113" pathLength={1} />
        {/* 3 — the seal + its one ring */}
        <circle className={s.seal} cx="60" cy="76" r="6.5" />
        <circle className={s.ring} cx="60" cy="76" r="6.5" pathLength={1} />
      </svg>
    </div>
  );
}
